

const initialState = {
  user: null,
  loading: false,
  error: null,
}

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'LOGIN_SUCCESS':
    case 'SET_USER':
      return {
        ...state,
        user: action.payload,
        loading: false,
        error: null,
      }
    case 'LOGOUT':
      return {
        ...state,
        user: null,
      }
    // Add other cases as needed
    default:
      return state
  }
}

export default authReducer